import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { IonButton, IonCol, IonIcon, IonItem, IonLabel, IonRow } from '@ionic/react';
import FormInput from '../form/formInput/FormInput';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import store from '../../store';
import { generateOtpQrCode } from '../../api/portal/auth.api';
import { IJwt } from '../../models/portal/auth.model';
import { eye, eyeOff, lockClosed } from 'ionicons/icons';
import { useToast } from '../../providers/ToastProvider';
import { IOtpQrCode } from '../../models/portal/otp.model';

interface IComponentProps {
  otpQrGenerationHandled: (data: IOtpQrCode, password: string) => void;
}

interface IFormInputs {
  password: string;
}

const schema = yup.object().shape({
  password: yup.string().required('password is required'),
});

const GenerateOtpQrCode: React.FC<IComponentProps> = ({ otpQrGenerationHandled }) => {
  const [isGeneratingQr, setIsGeneratingQr] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const {
    actions: { errorToast },
  } = useToast();

  const { control, handleSubmit } = useForm<IFormInputs>({
    defaultValues: {},
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  });

  const onSubmit = handleSubmit(async (data) => {
    const { databaseId, displayUsername } = store.getState().auth.token || ({} as IJwt);
    try {
      setIsGeneratingQr(true);
      const res = await generateOtpQrCode(displayUsername, data.password, databaseId || '0');
      otpQrGenerationHandled(res, data.password);
    } catch (ex: any) {
      errorToast('Failed to configure one-time password');
    } finally {
      setIsGeneratingQr(false);
    }
  });

  return (
    <>
      <IonLabel className="instruction-label">Authenticate using your password to begin.</IonLabel>

      <form id="userForm" className="ion-margin-top" noValidate onSubmit={onSubmit}>
        <IonRow>
          <IonCol>
            <IonItem className="input-group" lines="none">
              <FormInput control={control} type={showPassword ? 'text' : 'password'} placeholder="enter password" name="password" disabled={isGeneratingQr} />
              <IonButton fill="clear" onClick={() => setShowPassword((prev) => !prev)}>
                <IonIcon color="dark" icon={showPassword ? eyeOff : eye} />
              </IonButton>
              <IonIcon color="dark" className="field-icons" icon={lockClosed} />
            </IonItem>
          </IonCol>
        </IonRow>

        <IonRow>
          <IonButton type="submit" disabled={isGeneratingQr} className="flexed-fill">
            <span className="label">AUTHENTICATE</span>
          </IonButton>
        </IonRow>
        <button type="submit" className="hidden" />
      </form>
    </>
  );
};

export default GenerateOtpQrCode;
